import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    total: {
      color: theme.palette.primary.main,
      display: 'inherit',
      textAlign: 'right',
    },
    refund: {
      color: theme.palette.error.main,
      fontWeight: 500,
    },
  };
});

export default useStyles;
